import { SET_EVENTS, SET_PAST_EVENTS } from "../actions/action";

const initialState = {
  upcomingEvents: null,
  pastEvents: null,
};

const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EVENTS:
      return {
        ...state,
        upcomingEvents: action.payload,
      };
    case SET_PAST_EVENTS:
      return {
        ...state,
        pastEvents: action.payload,
      };
    default:
      return state;
  }
};

export default eventsReducer;
